import { Injectable, NgModuleRef } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalNavigatorComponent } from './modal-navigator.component';

@Injectable({
  providedIn: 'root',
})
export class ModalHelper {
  constructor(protected modalService: NgbModal, public activeModal: NgbActiveModal) {}

  public openStackedModal(modalComponent: any, options?: Partial<NgbModalOptions>): any {
    return this.modalService.open(modalComponent, options).componentInstance as ModalNavigatorComponent;
  }

  /**
   * Component should implement IMultiModalComponent interface
   *
   * @param startComponent the component to open
   * @param options
   * @param ngModuleRef
   */
  public openMultiViewModal(
    startComponent: any,
    options?: Partial<NgbModalOptions>,
    ngModuleRef?: NgModuleRef<any>
  ): any {
    const instance = this.modalService.open(ModalNavigatorComponent, this.getModalOptions(options))
      .componentInstance as ModalNavigatorComponent;

    // Pass ngModuleRef here to improve dependency injection
    return instance.initializeStartView(startComponent, ngModuleRef);
  }

  private getModalOptions(options?: Partial<NgbModalOptions>): NgbModalOptions {
    const modalOptions: NgbModalOptions = {
      // container: '#root', // append the modal to the #root container <div>, not to <body>
      backdrop: 'static',
    };

    Object.assign(modalOptions, options);

    return modalOptions;
  }
}
